import type { ColumnDef } from '@tanstack/react-table';
import { Badge } from '@mantine/core';
import { VariableValueCell } from './variableValueCell';
import { TruncatedText } from '~/components/common/TruncatedText';

// Sync with useTestVariables.tsx
export type LocalVariable = {
  name: string;
  valueType: string;
  definition: string;
  playwrightType: string;
  value?: string;
};

export const localVariableColumns: ColumnDef<LocalVariable>[] = [
  {
    id: 'name',
    header: 'Name',
    size: 75,
    accessorFn: (row) => row.name,
    cell: ({ row }) => {
      return (
        <div className="py-2">
          <span className="break-all text-sm font-medium text-gray-900 dark:text-gray-100">{row.original.name}</span>
        </div>
      );
    },
  },
  {
    id: 'definition',
    header: 'Definition',
    size: 100,
    // Value is a misnomer. The field actually contains the definition of the variable
    accessorFn: (row) => row.value,
    cell: ({ row }) => {
      const definition = row.original.definition || 'No definition';
      return (
        <div className="py-2">
          <TruncatedText
            text={definition}
            maxLength={100}
            modalTitle={`Variable definition for ${row.original.name}`}
            displayAsCode={true}
            showCopyButton={false}
          />
        </div>
      );
    },
  },
  {
    id: 'valueType',
    header: 'Type',
    size: 50,
    accessorFn: (row) => row.valueType,
    cell: ({ row }) => {
      return (
        <div className="py-2">
          <Badge
            size="sm"
            variant="light"
            color="blue"
            className="font-mono text-xs"
          >
            {row.original.valueType}
          </Badge>
        </div>
      );
    },
  },
  {
    id: 'value',
    header: 'Value',
    accessorFn: (row) => row.value,
    cell: ({ row }) => {
      return (
        <VariableValueCell
          name={row.original.name}
          value={row.original.value}
          parseAsJson={false}
        />
      );
    },
  },
];
